import getTopics from 'services/apiHelpers/getTopics';
import { Block } from '@chameleoncreator/creator-app';

export default () => {
  return getTopics().filter((t: Block) => {
    return t?.props?.asAssessment;
  });
};
